import { useState } from "react";
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import FleetAddCar from "./FleetAddCar";
import { btnOne } from "../../utils/style";
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { useRecoilState, useRecoilValue } from "recoil";
import arrowBlack from '../../assets/icons/arrow_black.png'
import FleetCreateWorkOrder from "./FleetCreateWorkOrder";
import fleetWorkOrderAtom from "../../atoms/fleetWorkOrderAtom";
import axios from "axios";
import { url } from "../../utils/config";
import { toast } from "react-toastify";
import loaderStateAtom from "../../atoms/loaderStateAtom";
import { calculateMaterialCost, calculateTotalCost, calculateTotalDiscount, calculateTotalFinalCost, calculateTotalTax, calculateTotalTechnicianCost } from "../../helper_functions/estimateCalculation"
import estimateFleetImageAtom from "../../atoms/estimateFleetImageAtom";
import FleetPreviewEstimate from "./FleetPreviewEstimate";


function FleetViewWorkOrder({ setShowModal, appointmentDetails, fetchFleetAppointmentDetails }) {

    const [openWorkEstimate, setOpenWorkEstimate] = useState(null);
    const [showAddCarModal, setShowAddCarModal] = useState(false);
    const [orderState, setOrderState] = useState("");
    const [workOrder, setWorkOrder] = useRecoilState(fleetWorkOrderAtom);
    const [showLoader, setShowLoader] = useRecoilState(loaderStateAtom)
    const fleetEstimateCars = appointmentDetails.fleet_work_estimates.map(estimate => estimate.fleet_customer_car)
    const [estimateFleetImage, setEstimateFleetImage] = useRecoilState(estimateFleetImageAtom);
    const technicianCost = appointmentDetails.technicianHourlyCost;
    const fromatedTaxRate = Number(appointmentDetails.taxRatePercent) / 100

    const toggleVIN = async (id, refreshEstimate) => {

        refreshEstimate && await refreshSelectedEstimate(id)
        setOpenWorkEstimate(prev => prev === id ? null : id);
        setOrderState("create")
    };

    const addCar = () => { setShowAddCarModal(true); };


    async function refreshSelectedEstimate(id) {
        try {
            if (!id) return

            setShowLoader(true)
            const reqUrl = url + '/fleet_work_estimation/' + id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers })

            const declineMessage = data.data.estimateDeclineMessage || null
            const bundleList = data.data.bundleList?.data.map((item) => { return { ...item, existingData: declineMessage ? false : true } }) || []
            const serviceList = data.data.serviceList?.data.map((item) => { return { ...item, existingData: declineMessage ? false : true } }) || []
            const materialList = data.data.materialList?.data.map((item) => { return { ...item, existingData: declineMessage ? false : true } }) || []
            const otherList = data.data.otherList?.data.map((item) => { return { ...item, existingData: declineMessage ? false : true } }) || []

            const newWorkOrder = {
                serviceBundle: { data: bundleList, note: '' },
                serviceList: { data: serviceList, note: '' },
                materialList: { data: materialList, note: '' },
                otherList: { data: otherList, note: '' },
                technicianCost: data.data.technicianCost || technicianCost,
                estimatedDate: data.data.estimatedDate || '',
                estimatedTime: data.data.estimatedTime || '',
                images: data.data.images || [],
                estimatedExpirationDate: data.data.estimatedExpirationDate || ''
            }
            setWorkOrder(newWorkOrder)
        } catch (error) {
            console.error("erron on estimate change", error)
        } finally {
            setShowLoader(false)
        }
    }


    async function updateFleetWorkOrder() {
        try {
            if (!workOrder.estimatedDate || !workOrder.estimatedTime) {
                toast.error('Please select both estimated date and time', { autoClose: 3000 });
                return;
            }
            if (workOrder.serviceBundle.data.length === 0 && workOrder.serviceList.data.length === 0 && workOrder.materialList.data.length === 0 && workOrder.otherList.data.length === 0) {
                toast.error('Please add at least one service bundle, service, material, or other cost', { autoClose: 3000 });
                return;
            }
            setShowLoader(true)
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}`, 'Content-Type': 'multipart/form-data' };

            const materialCost = calculateMaterialCost(workOrder.materialList)
            const tax = calculateTotalTax(workOrder.materialList, fromatedTaxRate)
            const totalCost = calculateTotalCost(workOrder.serviceList, workOrder.materialList, workOrder.otherList, workOrder.serviceBundle, technicianCost, fromatedTaxRate)
            const totalCostFinal = calculateTotalFinalCost(totalCost, tax)


            const updatedServiceList = { data: workOrder.serviceList.data.filter(item => !item.existingData) }
            const updatedMaterialList = { data: workOrder.materialList.data.filter(item => !item.existingData) }
            const updatedOtherList = { data: workOrder.otherList.data.filter(item => !item.existingData) }
            const updatedServiceBundle = { data: workOrder.serviceBundle.data.filter(item => !item.existingData) }

            const updatedTax = calculateTotalTax(updatedMaterialList, fromatedTaxRate)
            const updatedTotalCost = calculateTotalCost(updatedServiceList, updatedMaterialList, updatedOtherList, updatedServiceBundle, technicianCost, fromatedTaxRate)
            const updatedTotalCostFinal = calculateTotalFinalCost(updatedTotalCost, updatedTax)

            const totalDiscount = calculateTotalDiscount(workOrder.materialList, workOrder.serviceList, workOrder.serviceBundle)

            const updatedWorkOrder =
            {
                ...workOrder,
                materialCost: materialCost,
                tax: tax,
                totalCost: totalCost,
                totalCostFinal: totalCostFinal,
                newTotalCostFinal: updatedTotalCostFinal,
                customerId: appointmentDetails.fleet_customer.id,
                totalDiscount: totalDiscount,
                technicianCost: calculateTotalTechnicianCost(workOrder.serviceList, workOrder.materialList, workOrder.otherList, technicianCost),
                fleetBooking: { fleet_booking_id: appointmentDetails.id, bypassApproval: appointmentDetails.bypassApproval, taxRatePercent: appointmentDetails.taxRatePercent }
            }


            const formData = new FormData();

            formData.append('workOrder', JSON.stringify(updatedWorkOrder));
            estimateFleetImage.forEach((file, i) => {
                formData.append('images', file);
            });

            const res = await axios.patch(`${url}/fleet_work_estimation/${openWorkEstimate}`, formData, { headers });

            toast.success(res?.data?.message, { autoClose: 3000 })
            setOrderState("")
            setEstimateFleetImage([])
            setShowLoader(false)
            toggleVIN(openWorkEstimate, false)
        } catch (error) {
            setShowLoader(false)
            toast.error(error?.response?.data?.message || "Something went wrong", { autoClose: 3000 })
            console.log(error)
        }
    }

    return (
        <div>
            {showAddCarModal && (
                <FleetAddCar
                    setShowAddCarModal={setShowAddCarModal}
                    fleetCustomerID={appointmentDetails.fleet_customer.id}
                    fleetEstimateCars={fleetEstimateCars}
                    appointmentDetails={appointmentDetails}
                    fetchFleetAppointmentDetails={fetchFleetAppointmentDetails}
                    setOrderState={setOrderState}
                    toggleVIN={toggleVIN}
                />)}
            <div className="flex items-center mb-4">
                <button className=" hover:bg-gray-100 rounded-full" onClick={() => { setEstimateFleetImage([]); setShowModal(false); fetchFleetAppointmentDetails(appointmentDetails.id) }}>
                    <img src={arrowBlack} className="w-5 h-5" alt="back" />
                </button>
                <h2 className="text-lg font-bold ml-2">{appointmentDetails.fleet_customer.name}</h2>
                {appointmentDetails.bypassApproval === "yes" &&
                    <button onClick={addCar} className={`ml-auto border border-customOne rounded-lg py-2 px-6 text-center text-md text-white bg-customOne font-semibold`}>Add Car</button>
                }
            </div>

            {/* Accordion list */}
            {
                appointmentDetails.fleet_work_estimates.map((estimate) => {
                    const car = estimate.fleet_customer_car;

                    return (
                        <div key={estimate.id} className="border rounded mb-4 shadow">
                            <div
                                className="flex items-center justify-between px-4 py-3 bg-gray-100 cursor-pointer"
                                onClick={() => toggleVIN(estimate.id, true)}
                            >
                                <div>
                                    <p className="font-medium flex items-center gap-1">
                                        <DirectionsCarIcon fontSize="small" color="action" />
                                        {car.make} - {car.model} - {car.year}
                                    </p>
                                    <p className="text-blue-500"><span className="text-gray-800">#{estimate.id}</span> VIN: {car.vin}</p>
                                </div>
                                <div className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-400 transition-transform duration-300">
                                    <ChevronDownIcon
                                        className={`w-4 h-4 transition-transform ${openWorkEstimate === estimate.id ? "rotate-180" : ""}`}
                                    />
                                </div>
                            </div>
                            {
                                orderState === 'create' && openWorkEstimate === estimate.id && <FleetCreateWorkOrder setOrderState={setOrderState} appointmentDetails={appointmentDetails} workOrderId={openWorkEstimate} />
                            }
                            {
                                orderState === 'preview' && openWorkEstimate === estimate.id && <FleetPreviewEstimate setOrderState={setOrderState} updateFleetWorkOrder={updateFleetWorkOrder} />
                            }
                        </div>
                    );
                })
            }
        </div >
    );
}

export default FleetViewWorkOrder;
